import React, { forwardRef } from "react";
import { TextField } from "@mui/material";

const phoneInput = (props, ref) => (
  <TextField
    {...props}
    inputRef={ref}
    fullWidth
    size="small"
    label="Mobile Phone Number"
    variant="outlined"
    name="phone"
  />
);
export default forwardRef(phoneInput);
